import i18n from "@/i18n/index";

export const SEARCH_STATES = [
    {
        label: "searchCollapse",
        value: "collapsed"
    },
    {
        label: "searchExpanded",
        value: "expanded"
    }
];

export const TABLE_STATES = [
    {
        label: "tableFullscreen",
        value: "fullscreen"
    },
    {
        label: "tablePreview",
        value: "expanded"
    },
    {
        label: "tableCollapsed",
        value: "collapsed"
    }
];

export const TYPES_TRANSLATE = {
    "tab-tasks": i18n.t("liveView.tasksInstances.tasksTitle"),
    "tab-instances": i18n.t("liveView.tasksInstances.instancesTitle")
};

export const TABLE_TYPES = [
    {
        value: "tab-tasks",
        visible: true
    },
    {
        value: "tab-instances",
        visible: true
    }
];

export const TABLE_TYPES_TRANSLATE = {
    "tab-tasks": i18n.t("liveView.tasksInstances.tasksTitle"),
    "tab-instances": i18n.t("liveView.tasksInstances.instancesTitle")
};

export const TASKS_COLUMNS_TRANSLATE = {
    priority: i18n.t("liveView.tasksInstances.priority"),
    taskName: i18n.t("liveView.tasksInstances.taskName"),
    instanceName: i18n.t("liveView.tasksInstances.instanceName"),
    instanceID: i18n.t("liveView.tasksInstances.instanceId"),
    activity: i18n.t("liveView.tasksInstances.activity"),
    assignment: i18n.t("liveView.tasksInstances.assignment"),
    creationDate: i18n.t("liveView.tasksInstances.creationDate"),
    deadline: i18n.t("liveView.tasksInstances.deadline"),
    expiration: i18n.t("liveView.tasksInstances.expiration"),
    status: i18n.t("liveView.tasksInstances.status"),
    action: i18n.t("liveView.tasksInstances.action"),
    more: i18n.t("liveView.tasksInstances.more")
};

export const TABLE_TASKS_COLUMNS = [
    {
        value: "priority",
        visible: true
    },
    {
        value: "taskName",
        visible: true
    },
    {
        value: "instanceName",
        visible: true
    },
    {
        value: "instanceID",
        visible: true
    },
    {
        value: "activity",
        visible: true
    },
    {
        value: "assignment",
        visible: true
    },
    {
        value: "creationDate",
        visible: true
    },
    {
        value: "deadline",
        visible: true
    },
    {
        value: "expiration",
        visible: true
    },
    {
        value: "status",
        visible: true
    },
    {
        value: "action",
        visible: true
    },
    {
        value: "more",
        visible: true
    }
];

export const CASES_COLUMNS_TRANSLATE = {
    instanceName: i18n.t("liveView.tasksInstances.instanceName"),
    instanceID: i18n.t("liveView.tasksInstances.instanceId"),
    creationSource: i18n.t("liveView.tasksInstances.creationSource"),
    creationDate: i18n.t("liveView.tasksInstances.creationDate"),
    completionDate: i18n.t("liveView.tasksInstances.completionDate"),
    task: i18n.t("liveView.tasksInstances.instancesActivity"),
    endActivityName: i18n.t("liveView.tasksInstances.finalStage"),
    status: i18n.t("liveView.tasksInstances.status"),
    action: i18n.t("liveView.tasksInstances.action")
};

export const TABLE_CASES_COLUMNS = [
    {
        value: "instanceName",
        visible: true
    },
    {
        value: "instanceID",
        visible: true
    },
    {
        value: "creationSource",
        visible: true
    },
    {
        value: "creationDate",
        visible: true
    },
    {
        value: "completionDate",
        visible: true
    },
    {
        value: "endActivityName",
        visible: true
    },
    {
        value: "task",
        visible: true
    },
    {
        value: "status",
        visible: true
    },
    {
        value: "action",
        visible: true
    }
];

export const REPORTS_FILTERS_TRANSLATE = {
    search: i18n.t("generic.search"),
    activity: i18n.t("liveView.taskDetails.taskDescription"),
    taskStatus: i18n.t("liveView.filters.taskStatus"),
    instanceStatus: i18n.t("dashboard.instanceStatus"),
    fromDate: i18n.t("generic.from"),
    toDate: i18n.t("generic.to"),
    assignees: i18n.t("diagrams.components.variablesCard.users"),
    taskPriority: i18n.t("liveView.filters.taskPriorityTitle")
};

export const PERSPECTIVE_MORE_OPTIONS = [
    {
        label: i18n.t("perspectiveBuilder.duplicate"),
        value: "duplicate"
    },
    {
        label: i18n.t("perspectiveBuilder.delete"),
        value: "delete"

    }
];

export const REPORTS_FILTERS = [
    {
        value: "search",
        visible: true,
        fieldValue: [{ value: "" }],
        invisibleToUser: false
    },
    {
        value: "activity",
        visible: true,
        fieldValue: [{ value: "" }],
        invisibleToUser: false
    },
    {
        value: "taskStatus",
        visible: true,
        fieldValue: [{ value: [] }],
        invisibleToUser: false
    },
    {
        value: "instanceStatus",
        visible: true,
        fieldValue: [{ value: [] }],
        invisibleToUser: false
    },
    {
        value: "fromDate",
        visible: true,
        fieldValue: [{ value: "" }],
        invisibleToUser: false
    },
    {
        value: "toDate",
        visible: true,
        fieldValue: [{ value: "" }],
        invisibleToUser: false
    },
    {
        value: "assignees",
        visible: true,
        fieldValue: [{ filterType: "GROUP_IDS", value: [] }, { filterType: "USER_IDS", value: [] }],
        invisibleToUser: false
    },
    {
        value: "taskPriority",
        visible: true,
        fieldValue: [{ value: [] }],
        invisibleToUser: false
    }
];

export const DEFAULT_MODEL_DATA = {
    string: "example value",
    integer: "100",
    decimal: "3.14",
    attachment: "6a6e0849-4233-401b-88e0-2b40e51ae695-document.doc",
    boolean: "true"
};

export const DATETIME_FORMAT = {
    time: "HH:mm:ssZ",
    date: "YYYY-MM-DD",
    datetime: "YYYY-MM-DDTHH:mm:ssZ"
};

export const DATETIME_VARIABLES = {
    "s_ProcessInstance.startDateTime": "YYYY-MM-DDTHH:mm:ssZ",
    "s_Current.dateTime": "YYYY-MM-DDTHH:mm:ssZ",
    "s_Current.date": "YYYY-MM-DD",
    "s_Current.time": "HH:mm:ssZ"
};

function getDefaultData(type) {
    return {
        [`${type}.id`]: "4e1b4d22-facd-4088-ba23-16f925f46474",
        [`${type}.language`]: "en",
        [`${type}.gender`]: "male",
        [`${type}.code`]: "4e1b4d22-facd-4088-ba23-16f925f46474",
        [`${type}.firstName`]: "Alexandra",
        [`${type}.lastName`]: "Spencer",
        [`${type}.username`]: "alexandra.spencer@aurachain.ch",
        [`${type}.email`]: "alexandra.spencer@aurachain.ch",
        [`${type}.phone`]: "202-555-0177"
    };
}

export const DEFAULT_VARIABLES_DATA = {
    "s_ProcessDefinition.name": "Alexandra Spencer",
    ...getDefaultData("s_ProcessDefinition.owner"),
    "s_ProcessDefinition.id": "4e1b4d22-facd-4088-ba23-16f925f46474",
    "s_ProcessInstance.id": "4e1b4d22-facd-4088-ba23-16f925f46474",
    "s_ProcessInstance.signUpEmail": "alexandra.spencer@aurachain.ch",
    ...getDefaultData("s_ProcessInstance.initiator"),
    ...getDefaultData("s_Current.user"),
    "s_Task.id": "4e1b4d22-facd-4088-ba23-16f925f46474",
    "s_Environment.url": window.location.hostname,
    "s_Environment.tenantId": "4e1b4d22-facd-4088-ba23-16f925f46474",
    "s_Environment.tenantCode": "public"
};
export const TAB_TASKS_DEFAULT_DATA = {
    priority: "normal",
    processInstanceId: "4e1b4d22-facd-4088-ba23-16f925f46474",
    taskType: "TASK_PLUGIN",
    creationDate: new Date(),
    expirationTimeRemaining: "3599",
    timeRemaining: "-3599",
    status: "ON_TRACK",
    guiId: "4e1b4d22-facd-4088-ba23-16f925f46474"
};

export const TAB_INSTANCES_DEFAULT_DATA = {
    instanceId: "4e1b4d22-facd-4088-ba23-16f925f46474",
    startDate: new Date(),
    endDate: new Date(),
    systemStatus: "COMPLETED",
    endActivityId: "4e1b4d22-facd-4088-ba23-16f925f46474",
    creationSource: "Start",
    endActivityName: "End"
};
